export default __webpack_public_path__ + "static/customerpremises-2950cef2b913fdaf63adc01f6dba9af7.png";